<template>
  <div>
    <div class="date-picker mb-4">
      <vs-button size="small" @click="decrementDate"><feather-icon icon="ChevronLeftIcon" class="w-6 h-6"></feather-icon></vs-button>
      <div class="date">{{ todayOrSelectedDate }}</div>
      <vs-button size="small" @click="incrementDate"><feather-icon icon="ChevronRightIcon" class="w-6 h-6"></feather-icon> </vs-button>
    </div>
    <h2>Frontliners</h2>
    <vs-table v-if="hasLoaded" :data="tableData" class="data-list-container">
      <template slot="thead">
        <vs-th>User</vs-th>
        <vs-th v-for="location in locations" :key="location.id" class="location-header">{{ location.name }}</vs-th>
      </template>
      <template #default="{ data }">
        <vs-tr v-for="item in data" :key="item.id">
          <vs-td>{{ item.name }}</vs-td>
          <vs-td v-for="location in locations" :key="location.id">
            <vs-checkbox v-model="item.locations[location.id]" class="checkbox"></vs-checkbox>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <h2 class="mt-4 mb-2">Venue managers</h2>
    <div class="user-list">
      <vs-col v-for="user in availableVenueManagers" :key="user.userId" vs-w="3" class="mr-4">
        <vs-card class="user-card cursor-pointer" @click.native="toggleActive(user.userId)" :class="{ 'user-card--active': user.active }">
          <div class="user-card__header">
            <div class="user-card__name">{{ user.userDisplayName }}</div>
            <div class="user-card__role">Venue manager</div>
          </div>
          <!-- <div class="user-card__body">
            <vs-switch
              v-model="availableVenueManagers[idx].active"
             
              class="user-card__switch"
            ></vs-switch>
          </div> -->
        </vs-card>
      </vs-col>
    </div>

    <div class="mt-4">
      <vs-button color="primary" @click="saveChanges">Save Changes</vs-button>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  watch: {
    venueId: {
      handler: async function () {
        this.isLoading = true;
        this.activeVenueId = this.venueId;
        // If no venue id specified, default to active venue
        if (typeof this.venueId == "undefined") {
          this.activeVenueId = this.$store.getters["venues/activeVenueId"];
        }

        await Promise.all([
          this.getVenueManagers(),
          this.$store.dispatch("venues/getVenueUsers"),
          this.$store.dispatch("pos/venues/getVenue", this.activeVenueId)
        ]);
        await this.loadRequiredData();
        this.isLoading = false;
      },
      immediate: true
    }
  },
  data() {
    return {
      moment,
      hasLoaded: false,
      selectedDate: new Date().toISOString().substr(0, 10),
      availableVenueManagers: [],
      userLocations: {},
      activeVenueId: null
    };
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      venueUsers: "venues/venueUsers",
      waiterList: "pos/waiterList/waiterList",
      posLocations: "pos/venues/locations"
    }),
    locations() {
      return this.posLocations.map(location => ({
        id: location.locationId.id,
        name: location.name
      }));
    },
    tableData() {
      return this.venueUsers.map(user => ({
        id: user.userId,
        name: user.displayName,
        locations: this.userLocations[user.userId]
      })).sort((a, b) => a.name.localeCompare(b.name));
    },
    todayOrSelectedDate() {
      const today = new Date().toISOString().substr(0, 10);
      return this.selectedDate === today ? "Today" : this.prettifyDate(this.selectedDate);
    }
  },

  async mounted() {},
  methods: {
    toggleActive(userId) {
      const user = this.availableVenueManagers.find(user => user.userId === userId);
      const tmp = user.userDisplayName;
      user.userDisplayName = "";
      user.userDisplayName = tmp;
      user.active = !user.active;
    },
    async getVenueManagers() {
      this.availableVenueManagers = await this.$store.dispatch("venues/getUsersWithIdamRole", "vm");
      console.log("Waiter list: Venue Managers", this.availableVenueManagers);
    },
    prettifyDate(dateString) {
      const date = moment(dateString).format("DD MMM");
      return date;
    },
    async loadRequiredData() {
      const parsedDate = moment(this.selectedDate).format("MM-DD-YYYY");

      await this.$store.dispatch("pos/waiterList/getWaiterList", {
        venueId: this.activeVenueId,
        date: parsedDate
      }),
        console.log("Locations", this.posLocations);

      console.log("waiterlist", this.waiterList);
      this.userLocations = this.waiterList.waitersAndLocations;
      // Generate userLocations
      this.venueUsers.forEach(user => {
        if (!this.userLocations[user.userId]) this.userLocations[user.userId] = {};
        this.locations.forEach(location => {
          this.userLocations[user.userId][location.id] = this.userLocations[user.userId][location.id]
            ? this.userLocations[user.userId][location.id]
            : false;
        });
      });

      this.availableVenueManagers.forEach(user => {
        if (this.waiterList.venueManagers.includes(user.userId)) user.active = true;
        else user.active = false;
      });

      this.hasLoaded = true;
    },
    async saveChanges() {
      // Create dto where we filter out all users where all locations are false
      const tmp = {};

      // Filter out users with all locations set to false
      const filteredUsers = this.venueUsers.filter(user => {
        const userLocations = this.userLocations[user.userId];
        return Object.values(userLocations).some(location => location);
      });

      // Add filtered users to the DTO
      filteredUsers.forEach(user => {
        tmp[user.userId] = this.userLocations[user.userId];
      });

      let dto = this.waiterList;
      dto.venueManagers = this.availableVenueManagers.filter(user => user.active).map(user => user.userId);
      dto.waitersAndLocations = tmp;
      const result = await this.$store.dispatch("pos/waiterList/updateWaiterList", dto);
      console.log("Save result", result, "dto:", dto);
    },
    async incrementDate() {
      const date = new Date(this.selectedDate);
      date.setDate(date.getDate() + 1);
      this.selectedDate = date.toISOString().substr(0, 10);
      await this.loadRequiredData();
    },
    async decrementDate() {
      const date = new Date(this.selectedDate);
      date.setDate(date.getDate() - 1);
      this.selectedDate = date.toISOString().substr(0, 10);
      await this.loadRequiredData();
    }
  }
};
</script>

<style lang="scss">
.date-picker {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

.arrow {
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
}

.left {
  margin-right: 20px;
}

.right {
  margin-left: 20px;
}

.date {
  font-size: 24px;
  font-weight: bold;
  margin: 0 20px;
}

.checkbox {
  display: flex;
  justify-content: center;
  align-items: center;
}

.location-header {
  text-align: center;
}

.vs-checkbox {
  display: flex;
  justify-content: center;
  align-items: center;
}

.location-header .vs-table-text {
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: center;
  cursor: pointer;
}

// User List

.user-list {
  display: flex;
  flex-direction: row;
}

.user-card {
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  margin-bottom: 20px;
  overflow: hidden;
}

.user-card--active {
  border: 2px solid #42b983;
}

.user-card__header {
  background-color: #f5f5f5;
  padding: 10px;
}

.user-card__name {
  font-size: 18px;
  font-weight: bold;
}

.user-card__role {
  font-size: 14px;
  color: #666;
}

.user-card__body {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
}

.user-card__switch {
  margin: 0;
}
</style>